import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

export interface IReportApplyFiltersParams {
    appliedFilters: Record<string, string[]>; // the key is the filters category and the value is an array of applied filters from that category
    gamesCount: number;
}

interface IFilterEventData {
    action: string;
    label: string;
    actionData?: string;
}

export class AdvancedFiltersAnalytics {
    constructor(private readonly services: IServiceFactoryExtended) {

    }

    private _getLocation() {
        let location = this.services.location.currentUri.pathName.toString()
        if(location !== '/' && location.endsWith('/')) {
            location = location.substring(0, location.length - 1)
        }

        return location;
    }

    private _sendEvent(filterEventData: IFilterEventData): void {
        this.services.analytics.sendOrbitUserFlowEvent('advanced-filters', filterEventData.action, filterEventData.label, filterEventData.actionData);
    }

    reportOpenFilters(): void {
        this._sendEvent({
            action: 'open',
            label: this._getLocation()
        });
    }

    reportCloseFilters(): void {
        this._sendEvent({
            action: 'close',
            label: this._getLocation()
        });
    }

    reportClearFilters(): void {
        this._sendEvent({
            action: 'clear',
            label: this._getLocation()
        });
    }

    reportApplyFiltersByDeepLink(params: IReportApplyFiltersParams): void {
        this._sendEvent({
            action: 'deeplink',
            label: this._getLocation(),
            actionData: JSON.stringify(params)
        });
    }

    reportApplyFiltersByButton(params: IReportApplyFiltersParams): void {
        this._sendEvent({
            action: 'apply',
            label: this._getLocation(),
            actionData: JSON.stringify(params)
        });
    }

    reportRemoveFilter(filterID: string): void {
        this._sendEvent({
            action: 'remove',
            label: filterID
        });
    }
}